import { TokenBucket } from "./TokenBucket";

export class BucketRateLimiter {
  private buckets: Map<string, TokenBucket>;
  private defaultBucketCapacity: number;
  private defaultBucketFillRate?: number;

  constructor(bucketCapacity: number, bucketFillRate?: number) {
    this.buckets = new Map<string, TokenBucket>();
    this.defaultBucketCapacity = bucketCapacity;
    this.defaultBucketFillRate = bucketFillRate;
  }

  canCall(key: string): boolean {
    if (!this.buckets.has(key)) {
      this.buckets.set(
        key,
        new TokenBucket(this.defaultBucketCapacity, this.defaultBucketFillRate)
      );
    }
    return this.buckets.get(key)!.removeToken();
  }
}
